import { GIPHY_TYPE } from "./../../ricos-content";
const giphyStrategy = () => ({
  config: {
    [GIPHY_TYPE]: {
      giphySdkApiKey: "8LVphUXpyDK77BY7BhYMXgFU6TwhSKkA"
    }
  }
});
var giphyStrategy_default = giphyStrategy;
export {
  giphyStrategy_default as default
};
//# sourceMappingURL=giphyStrategy.js.map
